import React, { useState } from "react";
import "../auth.scss";
import { logodarkimg, logoimg } from "../../../assets/images";
import { callicon, messageicon } from "../../../assets/icons";
import Email from "./Email";
import Number from "./Number";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Forgot = () => {
  const [propertyTab, setPropertyTab] = useState("email");

  return (
    <>
      <Helmet defer={false}>
        <title>Reset Password | Holypills Account Recovery</title>
        <meta
          name="description"
          content="Forgot your Holypills password? Recover your account securely and regain access to your personalized health dashboard."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link rel="canonical" href="https://holypills.in/forgot" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Reset Password | Holypills Account Recovery"
        />
        <meta
          property="og:description"
          content="Forgot your Holypills password? Recover your account securely and regain access to your personalized health dashboard."
        />

        <meta property="og:url" content="https://holypills.in/forgot" />
        <meta property="og:site_name" content="Holypills"></meta>

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Reset Password | Holypills Account Recovery"
        />
        <meta
          name="twitter:description"
          content="Forgot your Holypills password? Recover your account securely and regain access to your personalized health dashboard."
        />

        <meta name="twitter:url" content="https://holypills.in/forgot"></meta>
      </Helmet>
      <div className="wrapper_auth wrapper_forgot wrapper_Otp ">
        <div className="wrap_left">
          <Link to={"/"}>
            <img src={logoimg} alt="logo" />
          </Link>
          <h1>
            Balance Your Body, <span></span> Empower Your Mind
          </h1>
        </div>
        <div className="wrap_right">
          <img className="logo" src={logodarkimg} alt="logo-image" />
          <h2>Forgot Password</h2>
          <p class="mail_code">
            No worries, We’ll send you instructions for reset
          </p>
          <div className="wrapper_cstm_tabers">
            <ul className="cstm_tabs">
              <li
                className={propertyTab === "email" ? "active" : ""}
                onClick={() => setPropertyTab("email")}
              >
                <img src={messageicon} alt="icon" />
                Email Address
              </li>
              <li
                className={propertyTab === "number" ? "active" : ""}
                onClick={() => setPropertyTab("number")}
              >
                <img src={callicon} alt="icon" />
                Mobile Number
              </li>
            </ul>
            {propertyTab === "email" && <Email />}
            {propertyTab === "number" && <Number />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgot;
